import React from "react";
import "./settings.css";
import SideBar from "./Components/SideBar/SideBar";
import ShipperUsers from "./Components/ManageShipperUsers/ManageShipperUsers";

function HelperUserSettings(props) {
  return (
    <>
      <div className="parent_wraper">
        {/* sidebar code  */}
        <SideBar active="1_0" />
        <div className="dash_table_wrapper">
          {/* right side secions  */}
          <ShipperUsers />
        </div>
      </div>
    </>
  );
}

export default HelperUserSettings;
